module.exports = __webpack_public_path__ + "static/media/collection-background.ea6dfcd8.jpg";